import * as Models from "../../ts/rlAdmin.models";
import * as Utils from "../../ts/rlAdmin.utils";
import * as Consts from "../../ts/rlAdmin.consts";
import { NotifyService } from "../../services/notify-service";
import { EntityConfigService } from "../../services/entity-config-service";
import { WorkflowConfigService } from "../../services/workflow-config-service";
import { AdminService } from "../../services/admin-service";
import { AdminConfigService } from "../../services/admin-config-service";
import * as angular from "angular";
import { foreachGraph } from "lodash";

export class TemplateConfigController {

    static $inject = ["$scope", "$window", "notifyService", "$q", "entityConfigService", "workflowConfigService", "adminService", "adminConfigService"];

    charTypeID: number;
    templateGroupID: number;
    selectedModelIDs: number[];
    editMode: boolean;
    templates: Models.ICharacteristicTemplate[];
    templateGroups: Models.ICharacteristicTemplateGroup[];
    processes: Models.IWFProcess[];
    amortizationModels: Models.AmortizationModel[];

    selectedTemplate: Models.ICharacteristicTemplate;
    originalTemplate: Models.ICharacteristicTemplate;
    templateAssociation: Models.ITemplateAssociationCollection;

    reIndexAffected: boolean;
    reIndexAffectedRecords: number;
    visibilityOptions: { key: number; value: string }[];
    selectedVisibility: { key: number; value: string };
    hasRecordsForTemplate: boolean;
    disabled: string[];
    associationsRequired: _.Dictionary<boolean> = {};
    rightsCharTypeID: number = Consts.CharTypeIDs.right;

    constructor(private $scope: ng.IScope,
        private $window: ng.IWindowService,
        private notifyService: NotifyService,
        private $q: ng.IQService,
        private entityConfigService: EntityConfigService,
        private workflowConfigService: WorkflowConfigService,
        private adminService: AdminService,
        private adminConfigService: AdminConfigService) {

        this.charTypeID = -1;
        this.templateGroupID;
        this.editMode = false;
        this.templates = [];
        this.templateGroups = [];
        this.processes = [];
        this.amortizationModels = [];
        this.selectedModelIDs = [];

        this.selectedTemplate = null;
        this.originalTemplate = null;
        this.selectedVisibility = null;

        this.reIndexAffected = false;
        this.reIndexAffectedRecords = 0;
        this.visibilityOptions = null;
        this.hasRecordsForTemplate = false;
        this.disabled = [];

        this.$scope.$watch(() => this.reIndexAffectedRecords, (newValue: number, oldValue: number) => {
            if (newValue != oldValue && newValue > 0) {
                this.reIndexAffected = true;
            }
        }, true);

    }

    Init(charTypeID: number, templateGroupID: number) {
        this.notifyService.startProgress();
        this.charTypeID = charTypeID;
        this.templateGroupID = templateGroupID;
        this.$q.all([this.LoadTemplates(charTypeID, templateGroupID), this.LoadTemplateGroups(charTypeID), this.LoadWFProcesses(), this.LoadAmortizationModels()])
            .then(() => {
                this.LoadVisibilityOptions();
                this.notifyService.endProgress();
            });
    }

    GetRecordAssociationCharacteristicTemplateRequired(charTypeID: number, templateID: number, childCharTypeID: number) {
        this.entityConfigService.getRecordAssociationCharacteristicTemplateRequired(charTypeID, templateID, childCharTypeID)
            .then((res) => {
                if (res && res.charTypeID) {
                    this.associationsRequired[childCharTypeID.toString()] = true;
                } else {
                    this.associationsRequired[childCharTypeID.toString()] = false;
                }
            });
    }

    CreateRecordAssociationConfigurationRequiredEntry(charTypeID: number, templateID: number, childCharTypeID: number) {
        this.notifyService.startProgress();
        this.entityConfigService.createRecordAssociationConfigurationRequiredEntry(charTypeID, templateID, childCharTypeID)
            .then((res) => {
                this.associationsRequired[childCharTypeID.toString()] = true;
            })
            .catch((err) => {
                this.notifyService.notifyError("Error setting required associations");
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    DeleteRecordAssociationConfigurationRequiredEntry(charTypeID: number, templateID: number, childCharTypeID: number) {
        this.notifyService.startProgress();
        this.entityConfigService.deleteRecordAssociationConfigurationRequiredEntry(charTypeID, templateID, childCharTypeID)
            .then((res) => {
                this.associationsRequired[childCharTypeID.toString()] = false;
            })
            .catch((err) => {
                this.notifyService.notifyError("Error removing required associations");
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    ToggleRecordAssociationConfigurationRequiredEntry(charTypeID: number, templateID: number, childCharTypeID: number) {
        if (this.associationsRequired[childCharTypeID.toString()]) {
            this.DeleteRecordAssociationConfigurationRequiredEntry(charTypeID, templateID, childCharTypeID);
        } else {
            this.CreateRecordAssociationConfigurationRequiredEntry(charTypeID, templateID, childCharTypeID);
        }
    }

    LoadTemplateAssociationList(charTypeID: number, templateID: number) {
        this.charTypeID = charTypeID;
        this.entityConfigService.getCharTypeTemplateAssociationList(charTypeID, templateID, false).then((results) => {
            this.templateAssociation = results;
            var childCharTypeIDs = _.map(this.templateAssociation.charTypeAssociationList, (ca) => { return ca.charTypeID; });
            childCharTypeIDs.forEach((childCharTypeID) => {
                this.GetRecordAssociationCharacteristicTemplateRequired(charTypeID, templateID, childCharTypeID);
            });
        });

    };

    UpdateTemplateRelationship(templateID: number, charTypeID: number, childCharTypeID: number, childTemplateID: number, description: string) {
        var item = _.find(this.templateAssociation.templateAssociationList, (char) => char.childCharTypeID === childCharTypeID && char.childTemplateID === childTemplateID);
        item.relRecTypeID = item.selected ? 1 : 2;

        if (item.selected && charTypeID == Consts.CharTypeIDs.property && childCharTypeID == Consts.CharTypeIDs.property) {
            this.UpdateRightsRelTemplateRelationship(templateID, charTypeID, childCharTypeID, childTemplateID, description);
        }
        else {
            var key = this.GetKey(templateID, charTypeID, childCharTypeID, childTemplateID);
            this.AddToDisabledList(key);

            if (item.selected == false && charTypeID == Consts.CharTypeIDs.property && childCharTypeID == Consts.CharTypeIDs.property) {
                item.relRecTypeID = -1;
            }

            try {
                this.notifyService.startProgress();
                this.entityConfigService.updateTemplateRelationship(charTypeID, templateID, childCharTypeID, childTemplateID, item.relRecTypeID, item.selected).then((results) => {
                    if (results) {
                        this.notifyService.notifySuccess("Settings Updated");
                    }
                    else {
                        this.notifyService.notifyError("Error Updating: " + description);
                    }

                    this.RemoveFromDisabledList(key);
                });
            }
            finally {
                this.notifyService.endProgress();
            }
        }

    }

    UpdateRightsRelTemplateRelationship(templateID: number, charTypeID: number, childCharTypeID: number, childTemplateID: number, description: string) {
        var item = _.find(this.templateAssociation.templateAssociationList, (char) => char.childCharTypeID === childCharTypeID && char.childTemplateID === childTemplateID);

        if (charTypeID == Consts.CharTypeIDs.property && childCharTypeID == Consts.CharTypeIDs.property && item.relRecTypeID >= 1) {
            var key = this.GetKey(templateID, charTypeID, childCharTypeID, childTemplateID);
            this.AddToDisabledList(key);
            item.selected = true;
            try {
                this.notifyService.startProgress();
                this.entityConfigService.updateRightsRelTemplateRelationship(charTypeID, templateID, childCharTypeID, childTemplateID, item.relRecTypeID).then((results) => {
                    if (results) {
                        this.notifyService.notifySuccess("Settings Updated");
                    }
                    else {
                        this.notifyService.notifyError("Error Updating: " + description);
                    }

                    this.RemoveFromDisabledList(key);
                });
            }
            finally {
                this.notifyService.endProgress();
            }
        }
        else {
            if (item.selected == false) {
                item.relRecTypeID = -1;
            }
        }
    }


    IsDisabled(templateID: number, charTypeID: number, childCharTypeID: number, childTemplateID: number) {
        var key = this.GetKey(templateID, charTypeID, childCharTypeID, childTemplateID);
        return _.includes(this.disabled, key);
    }

    GetKey(templateID: number, charTypeID: number, childCharTypeID: number, childTemplateID: number) {
        return `${templateID}.${charTypeID}.${childCharTypeID}.${childTemplateID}`;
    }

    AddToDisabledList(key: string) {
        if (!_.includes(this.disabled, key)) {
            this.disabled.push(key);
        }
    }

    RemoveFromDisabledList(key: string) {
        _.pull(this.disabled, key);
    }

    LoadWFProcesses(): ng.IPromise<any> {
        return this.workflowConfigService.getProcesses(this.charTypeID)
            .then((result) => {
                this.processes = result;
            });
    }

    LoadAmortizationModels(): ng.IPromise<any> {
        return this.adminConfigService.getAmortizationList()
            .then(result => {
                this.amortizationModels = result.data;
            });
    }

    LoadVisibilityOptions(): ng.IPromise<any> {
        return this.entityConfigService.getVisibilityOptions()
            .then((result) => {
                this.visibilityOptions = result;
            });
    }
    LoadTemplateGroups(charTypeID: number): ng.IPromise<any> {
        return this.entityConfigService.getCharacteristicTemplateGroups(charTypeID)
            .then((results) => {
                this.templateGroups = results;
            });
    }

    LoadTemplates(charTypeID: number, templateGroupID: number): ng.IPromise<any> {
        return this.entityConfigService.getCharacteristicTemplates(charTypeID)
            .then((results) => {

                if (templateGroupID == -1) {
                    if (charTypeID == Consts.CharTypeIDs.transaction) {
                        this.templates = _.filter(results, r => { return r.templateGroupID != Consts.TemplateGroupIDs.JobTemplateGroup; });
                    }
                    else {
                        this.templates = results;
                    }
                }
                else {
                    this.templates = _.filter(results, r => { return r.templateGroupID == templateGroupID; });
                }
            });
    }

    Edit(template: Models.ICharacteristicTemplate) {
        if (this.charTypeID === 4) {
            this.adminConfigService.getTemplateAmortizationModelAssociation(template.templateID).then(result => {
                this.selectedModelIDs = _.any(result.data) ? result.data : [0];
            });
        }

        return this.entityConfigService.getEntityListCountByTemplate(this.charTypeID, template.templateID)
            .then((result) => {
                if (result.data > 0) {
                    this.hasRecordsForTemplate = true;
                }
                else {
                    this.hasRecordsForTemplate = false;
                }
                this.editMode = true;
                this.selectedVisibility = _.find(this.visibilityOptions, v => { return v.key == template.visibilityIndicator; });
                template.charTypeID = this.charTypeID;
                this.selectedTemplate = <Models.ICharacteristicTemplate>angular.copy(template);
                this.originalTemplate = <Models.ICharacteristicTemplate>angular.copy(template);
            });
    }

    Reset() {
        this.selectedTemplate = null;
    }

    Cancel(form: ng.IFormController) {
        form.$setPristine();
        this.LoadTemplates(this.charTypeID, this.templateGroupID)
            .then(() => {
                this.editMode = false;
                this.Reset();
                this.notifyService.broadcastDone();
            });
    }

    toggleSelectedModel(id: number) {
        var idx = this.selectedModelIDs.indexOf(id);
        // Is currently selected
        if (idx > -1) {
            this.selectedModelIDs.splice(idx, 1);
        }

        // Is newly selected
        else {
            this.selectedModelIDs.push(id);
        }
    }

    Save(form: ng.IFormController): ng.IPromise<any> {
        if (form.$valid) {
            this.notifyService.startProgress();
            this.selectedTemplate.visibilityIndicator = this.selectedVisibility.key;

            if (this.selectedTemplate.charTypeID === Consts.CharTypeIDs.transaction) {
                this.adminConfigService.updateTemplateAmortizationModelAssociation(this.selectedTemplate.templateID, this.selectedModelIDs);
            }
            
            return this.entityConfigService.updateCharacteristicTemplate(this.selectedTemplate)
                .then(result => {
                    if (result) {
                        this.editMode = false;
                        this.notifyService.notifySuccess("Template updated successfully!");
                        this.LoadTemplates(this.charTypeID, this.templateGroupID)
                            .then(() => {
                                this.editMode = false;
                            });

                        if (this.selectedTemplate.templateName != this.originalTemplate.templateName || this.selectedTemplate.systemIndicator != this.originalTemplate.systemIndicator || this.selectedTemplate.templateGroupID != this.originalTemplate.templateGroupID) {
                            this.entityConfigService.getAffectedEntitiesCount(this.selectedTemplate)
                                .then((result) => {
                                    if (result.data > 0) {
                                        this.reIndexAffectedRecords = result.data;
                                        this.UpdateTemplateRelatedEntities(this.selectedTemplate);
                                        this.ReIndexAffectedRecords();
                                    }
                                });
                        }
                    }
                    else {
                        this.notifyService.notifyError("There was a problem updating the template.");
                    }
                })
                .finally(() => {
                    this.notifyService.endProgress();
                });
        }
    }

    ReIndexAffectedRecords() {
        this.reIndexAffected = true;
    }

    UpdateTemplateRelatedEntities(request: Models.ICharacteristicTemplate) {
        this.entityConfigService.bulkUpdateRelatedEntitiesByTemplate(request)
            .then(() => {
                this.notifyService.notifySuccess("Related entities updated successfully.");
                this.ClearCacheForDiv();
            });
    }

    ClearCacheForDiv() {
        this.notifyService.startProgress();
        this.adminService.clearCacheForDiv()
            .then(() => {
                this.notifyService.notifySuccess("Cache Cleared");
            })
            .finally(() => {
                this.notifyService.endProgress();
            });
    }

    Delete(template: Models.ICharacteristicTemplate) {
    }

    UpdateSequenceNumber(templateID: number, direction: boolean) {
        this.notifyService.startProgress();
        return this.entityConfigService.updateTemplateSequenceNumber(this.charTypeID, templateID, direction)
            .then((result) => {
                return this.LoadTemplates(this.charTypeID, this.templateGroupID)
                    .then(() => {
                        this.notifyService.broadcastDone();
                        this.notifyService.notifySuccess("Template Sequence Numbers updated successfully");
                    });
            }).finally(() => {
                this.notifyService.endProgress();
            });
    }

    CopyTemplate(templateID: number) {
        this.notifyService.startProgress();
        return this.entityConfigService.copyCharacteristicTemplate(this.charTypeID, templateID)
            .then((result) => {
                if (result.data) {
                    this.notifyService.notifySuccess("Copy Template Successful");
                }
                else {
                    this.notifyService.notifyError("Copy Template Failed");
                }
            }).finally(() => {
                this.notifyService.endProgress();
                return this.Init(this.charTypeID, this.templateGroupID);
            });
    }
}
